<template>
  <div>

    <div>
      <div style="margin-bottom: 15px">
        <label>训练项目：</label>
        <el-cascader :options="cateTree" :props="{ checkStrictly: true }" clearable @change="onChangeHandle">
        </el-cascader>

        <el-select v-model="value2" clearable :disabled="this.disabled " placeholder="请选择项目" @clear="clearHandle" @change="onPracticeChange">
          <el-option v-for="item in practiceList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>

      </div>
      <div v-loading="loading">
        <div>
          <div style="width: 50%;float: left;height: 180px;">
            <ve-pie :data="chartData" :settings="chartSettings"></ve-pie>
          </div>
          <ul class="details-page-stat-shared">
            <li class="first">
              <div class="icon"><i class="el-icon-time"></i></div>
              <div class="label">训练时长 <span>{{formatSeconds(allTime)}}</span>

              </div>
            </li>
            <li class="second" @click="dialogTableVisible = true">
              <div class="icon"><i class="el-icon-menu"></i></div>
              <div class="label">班级排名 <span>{{classSort}}</span>
              </div>
            </li>
            <li class="third" @click="dialogTableVisible2 = true">
              <div class="icon"><i class="el-icon-share"></i></div>
              <div class="label">年级排名 <span>{{gradeSort}}</span>

              </div>

            </li>
          </ul>
          <el-dialog title="班级前五排名" :visible.sync="dialogTableVisible" width="30%">
            <el-table :data="classData">
              <el-table-column label="排名" width="150">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.$index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column property="name" label="姓名" width="200"></el-table-column>
              <el-table-column property="avg" label="得分"></el-table-column>
            </el-table>
          </el-dialog>

          <el-dialog title="年级前五排名" :visible.sync="dialogTableVisible2" width="30%">
            <el-table :data="gradeData">
              <el-table-column label="排名" width="150">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.$index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column property="name" label="姓名" width="200"></el-table-column>
              <el-table-column property="avg" label="得分"></el-table-column>
            </el-table>
          </el-dialog>
        </div>
        <div style="min-height: 400px">
          <el-table ref="filterTable" :data="tableData" style="width: 100%">
            <el-table-column prop="created_at" label="训练日期" sortable width="180" column-key="date">
            </el-table-column>
            <el-table-column prop="learn_id" label="训练项目" :formatter="formatterLearn">
            </el-table-column>
            <el-table-column prop="total_score" label="得分">
              <template slot-scope="scope">
                {{scope.row.total_score>=0?scope.row.total_score:'--'}}
              </template>
            </el-table-column>
            <el-table-column prop="total_time" label="用时" :formatter="formatter">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" v-if="scope.row.total_score>=0">查看
                </el-button>
                <el-button size="mini" disabled="disabled" @click="handleEdit(scope.$index, scope.row)" v-else>查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>
        <div style="text-align: right" v-if="pageform.total>pageform.pageSize">
          <el-pagination background @current-change="pageCurrentChange" :page-count="pageform.pages" :current-page="pageform.pageNum" layout="prev, pager, next" :total="pageform.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <div>
      <router-view>
      </router-view>
    </div>

  </div>
</template>

<script>
import VePie from 'v-charts/lib/pie.common'
import { categoryTree } from "../../restful/api";

export default {
  components: { VePie },
  name: 'Practices',

  data() {
    this.chartSettings = {
      radius: 50,
      offsetY: 100,
      label: {
        show: false
      }
    };
    return {
      cateTree: [],
      classData: [],
      gradeData: [],
      classSort: 0,
      gradeSort: 0,
      dialogTableVisible: false,
      dialogTableVisible2: false,
      chartData: {
        columns: ['成绩', '次数'],
        rows: [
          { '成绩': '优秀', '次数': 0 },
          { '成绩': '达标', '次数': 0 },
          { '成绩': '不达标', '次数': 0 },
        ]
      },
      // 分页插件
      pageform: {
        total: 0,
        pages: 5,  // 总页数
        pageNum: 1, // 当前的页码
        pageSize: 9, // 每页显示条目个数
      },
      tableData: [],
      practiceList: [],
      categoryList: [],
      allTime: 0,
      value: '',
      value2: '',
      loading: true,
      disabled: true,
      params: {
        class_id: this.$store.getters.getUserInfo.class_id
      },
      params2: {
        page_size: 10,
        page: 1,
        user_id: this.$store.getters.getUserInfo.id,
      },
    }
  },
  methods: {
    formatter(row) {
      return this.formatSeconds(row.total_time)
    },
    /* 分页插件 */
    // pageNum (当前页数)改变时会触发
    pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
      this.pageform.pageNum = val;
      this.params2.page = val;
      this.getScore();
    },
    onPracticeChange(learn_id) {
      this.params2.learn_id = learn_id;
      this.params2.page = 1;
      this.pageform.pageNum = 1;
      this.getScore();
    },
    //获取分类树
    getCategoryTree() {
      categoryTree().then((res => {
        var arr = []
        var obj = {}
        for (var i = 0; i < res.data.length; i++) {
          obj = {}
          obj.value = res.data[i].value
          obj.label = res.data[i].label
          if (res.data[i].children.length > 0) {
            obj.children = res.data[i].children
          }
          arr.push(obj)
        }
        this.cateTree = arr;
      }))
    },
    // 获取分类列表
    getCategoryList() {
      this.practiceList = [];
      this.$http.categoryList()
        .then(res => {
          if (res.code !== 0) {
            this.categoryList = res.data;
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleEdit(index, row) {
      this.$router.push({
        name: 'practiceDetail',
        query: {
          id: row.id
        }
      })
    },
    getScore() {
      this.$http.getScore(this.params2).then(res => {
        if (res.code !== 0) {
          this.tableData = res.data.score;
          this.loading = false;
          this.pageform.pages = res.data.allPage;
          this.pageform.total = res.data.times;
          this.allTime = res.data.allTime;
          this.classData = res.data.class.class_sort;
          this.gradeData = res.data.grade.grade_sort;
          this.classSort = res.data.class.sort;
          this.gradeSort = res.data.grade.sort;
          this.chartData.rows[0].次数 = res.data.dabiao.height;
          this.chartData.rows[1].次数 = res.data.dabiao.middle;
          this.chartData.rows[2].次数 = res.data.dabiao.low;
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onChangeHandle(category_ids) {
      let length = (category_ids.length) - 1;
      let category_id = category_ids[length];
      this.disabled = false;
      this.params2.page = 1;
      this.pageform.pageNum = 1;
      this.params2.category_id = category_id;
      this.getCourseList(category_id);
      this.getScore()
    },
    clearHandle() {
      delete this.params2.learn_id;
    },
    // 获取训练列表
    getCourseList(category_id) {
      this.practiceList = [];
      this.params.category_id = category_id;
      this.$http.courseAllList({ category_id: category_id })
        .then(res => {
          if (res.code !== 0) {
            this.practiceList = res.data.learn
          } else {
            this.$message.error(res.message)
          }
        })
    },
    formatterLearn(row, column) {
      var name = '';
      this.practiceList.forEach(function (i, v) {
        if (row.learn_id == i.id) {
          name = i.name;
        }
      });
      return name;
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },


  },
  created() {
    this.getCategoryList();
    this.getCategoryTree();
    this.getScore();
    this.getCourseList();
  }
}
</script>
<style>
.details-page-stat-shared {
  width: 50%;
  display: block;
  padding-bottom: 12px;
  float: right;
  margin-top: 30px;
}

.details-page-stat-shared > li {
  display: block;
  width: 100%;
}

.details-page-stat-shared > li:after {
  content: "";
  display: table;
  clear: both;
}

.details-page-stat-shared > li + li {
  margin-top: 6px;
}

.details-page-stat-shared > li .icon {
  float: left;
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  position: relative;
}

.details-page-stat-shared > li .icon:after {
  content: "";
  display: block;
  height: 5px;
  width: 2px;
  background-color: inherit;
  position: absolute;
  top: 50%;
  margin-top: -2px;
  right: -2px;
}

.details-page-stat-shared > li .label {
  float: left;
  border-radius: 3px;
  line-height: 25px;
  height: 25px;
  padding: 0 10px;
  font-size: 12px;
  margin-left: 2px;
  max-width: 160px;
}

.details-page-stat-shared > li.first .icon {
  background-color: #d97408;
  color: #fff;
  border-radius: 4px;
}

.details-page-stat-shared > li.first .icon .iconfont {
  font-size: 13px;
}

.details-page-stat-shared > li.first .label {
  background-color: #d97408;
  color: #fff;
}

.details-page-stat-shared > li.second .icon {
  background-color: #4976e8;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.details-page-stat-shared > li.second .icon .iconfont {
  font-size: 18px;
}

.details-page-stat-shared > li.second .label {
  background-color: #4976e8;
  color: #fff;
  cursor: pointer;
}

.details-page-stat-shared > li.third .icon {
  background-color: #339900;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.details-page-stat-shared > li.third .icon .iconfont {
  font-size: 25px;
}

.details-page-stat-shared > li.third .label {
  background-color: #339900;
  color: #fff;
  cursor: pointer;
}

.details-page-stat-shared > li.third .icon:after {
  background-color: #339900;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Practices.vue